// Tabs with the sliding gold underline. Arrow keys move between tabs (roving tabindex).
import type { ReactNode } from 'react';

export interface TabDef<T extends string> { id: T; label: ReactNode; badge?: ReactNode; disabled?: boolean; testId?: string }

export function Tabs<T extends string>({ tabs, value, onChange, label, className = '' }: { tabs: ReadonlyArray<TabDef<T>>; value: T; onChange: (id: T) => void; label: string; className?: string }) {
  const move = (dir: 1 | -1) => {
    const enabled = tabs.filter((t) => !t.disabled);
    const i = enabled.findIndex((t) => t.id === value);
    const next = enabled[(i + dir + enabled.length) % enabled.length];
    if (next) onChange(next.id);
  };
  return (
    <div className={`fk-tabs ${className}`} role="tablist" aria-label={label} onKeyDown={(e) => { if (e.key === 'ArrowRight') { e.preventDefault(); move(1); } if (e.key === 'ArrowLeft') { e.preventDefault(); move(-1); } }}>
      {tabs.map((t) => <button key={t.id} type="button" role="tab" className="fk-tab" aria-selected={t.id === value} tabIndex={t.id === value ? 0 : -1} disabled={t.disabled} onClick={() => onChange(t.id)} data-testid={t.testId}>{t.label}{t.badge}</button>)}
    </div>
  );
}

export function TabPanel({ children, className = '', ...rest }: { children: ReactNode; className?: string } & Record<string, unknown>) {
  return <div role="tabpanel" className={`fk-tabpanel ${className}`} {...rest}>{children}</div>;
}
